import { Image } from "antd";
import { FileOutlined } from "@ant-design/icons";
import urlJoin from "url-join";
import { remoteServiceBaseUrl } from "src/shared/constants/AppConst";
import { ChatAttachmentDto } from "src/shared/services/chat/dto";
import {
  CHAT_IMAGE_PREVIEW_Z_INDEX,
  isPreviewableImage,
} from "src/shared/services/chat/attachments";
import "./styles.less";

interface MessageAttachmentsProps {
  attachments: ChatAttachmentDto[];
}

const MessageAttachments: React.FC<MessageAttachmentsProps> = ({
  attachments,
}) => {
  const images = attachments.filter((a) => isPreviewableImage(a.type));
  const files = attachments.filter((a) => !isPreviewableImage(a.type));
  const getUrl = (attachment: ChatAttachmentDto) =>
    urlJoin(remoteServiceBaseUrl ?? "", attachment.url);

  return (
    <div className="message-attachments">
      {images.length > 0 && (
        <div className="attachment-images">
          <Image.PreviewGroup
            preview={{ zIndex: CHAT_IMAGE_PREVIEW_Z_INDEX }}
          >
            {images.map((image) => (
              <Image
                key={image.id}
                src={getUrl(image)}
                alt={image.name}
                width={images.length === 1 ? 200 : 96}
                height={images.length === 1 ? undefined : 96}
                className="attachment-image"
              />
            ))}
          </Image.PreviewGroup>
        </div>
      )}

      {files.map((file) => (
        <a
          key={file.id}
          href={getUrl(file)}
          target="_blank"
          rel="noopener noreferrer"
          download={file.name}
          className="attachment-file"
          title={file.name}
        >
          <FileOutlined className="attachment-file-icon" />
          <span className="attachment-file-name">{file.name}</span>
        </a>
      ))}
    </div>
  );
};

export default MessageAttachments;
